/**
 * Categories API — Supabase PostgREST.
 */

import supabase from "../config/supabase";

const categoriesApi = {
  async list(params = {}) {
    // Retired categories stay in the table so old listings keep their history,
    // but they must not appear in the pickers. Mobile Mechanic is the first one
    // (folded into Mechanic in 052).
    let query = supabase
      .from("categories")
      .select("*")
      .eq("is_active", true)
      .order("name", { ascending: true });
    if (params.type) query = query.eq("type", params.type);
    const { data, error } = await query;
    if (error) return { success: false, error: error.message };
    return { success: true, data: data || [] };
  },
};

export default categoriesApi;
